import React from 'react';
import PublicLayout from '../Layout';
import './referral-partner-register.less';

class Layout extends React.Component {
    public render(): JSX.Element {
        return (
            <PublicLayout contactEmail='referral-partners@funding.com.au' showLogin={false}>
                <div className='referral-partner-register'>
                    {this.props.children}
                </div>
            </PublicLayout>
        );
    }
}

export default Layout;
